<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-p2-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-p2-badge">Property + USP + 2x Photo</span>

  <div class="cr-p2-image-row">
    <div
      class="cr-p2-dropzone"
      [appInlineMedia]="block.variables?.['PropertyUsp2x1Image']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'PropertyUsp2x1Image')"
    >
      <a *ngIf="block.variables?.['PropertyUsp2x1Image']; else empty1" [href]="image1Href" target="_blank" rel="noopener">
        <img [src]="block.variables?.['PropertyUsp2x1Image']" [alt]="block.variables?.['PropertyUsp2x1ImageAlt'] || ''" />
      </a>

      <ng-template #empty1>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div
      class="cr-p2-dropzone"
      [appInlineMedia]="block.variables?.['PropertyUsp2x2Image']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'PropertyUsp2x2Image')"
    >
      <a *ngIf="block.variables?.['PropertyUsp2x2Image']; else empty2" [href]="image2Href" target="_blank" rel="noopener">
        <img [src]="block.variables?.['PropertyUsp2x2Image']" [alt]="block.variables?.['PropertyUsp2x2ImageAlt'] || ''" />
      </a>

      <ng-template #empty2>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>
  </div>

  <span
    class="cr-p2-name"
    [appInlineEdit]="block.variables?.PropertyUsp2xName ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert property name"
    (inlineEditChange)="onChange($event, 'PropertyUsp2xName')"
  ></span>

  <ul class="cr-p2-usp-list">
    <li class="cr-p2-usp-row">
      <img class="cr-p2-checkmark" [src]="checkmarkIconUrl" alt="" />
      <span
        class="cr-p2-usp-text"
        [appInlineEdit]="block.variables?.PropertyUsp2x1Usp ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert USP text 1"
        (inlineEditChange)="onChange($event, 'PropertyUsp2x1Usp')"
      ></span>
    </li>
    <li class="cr-p2-usp-row">
      <img class="cr-p2-checkmark" [src]="checkmarkIconUrl" alt="" />
      <span
        class="cr-p2-usp-text"
        [appInlineEdit]="block.variables?.PropertyUsp2x2Usp ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert USP text 2"
        (inlineEditChange)="onChange($event, 'PropertyUsp2x2Usp')"
      ></span>
    </li>
    <li class="cr-p2-usp-row">
      <img class="cr-p2-checkmark" [src]="checkmarkIconUrl" alt="" />
      <span
        class="cr-p2-usp-text"
        [appInlineEdit]="block.variables?.PropertyUsp2x3Usp ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert USP text 3"
        (inlineEditChange)="onChange($event, 'PropertyUsp2x3Usp')"
      ></span>
    </li>
  </ul>

  <!-- No edit control for these (matches v1) - shown read-only when already set. -->
  <a
    class="cr-p2-cta"
    *ngIf="block.variables?.PropertyUsp2xCtaLink"
    [href]="helper.getFullUrl(block.variables?.['PropertyUsp2xCtaLink'])"
    target="_blank"
    rel="noopener"
  >
    {{ block.variables?.PropertyUsp2xCtaText }}
  </a>
</div>

<!-- Right panel: real edit form -->
<div class="cr-p2-edit" *ngIf="!isPreview">
  <div class="cr-p2-field-row">
    <span class="cr-p2-field-label">First Image</span>
    <span
      class="cr-p2-toggle"
      [class.cr-p2-toggle-on]="image1AsUpload"
      role="button"
      tabindex="0"
      [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImage1Mode()"
      (keydown.enter)="toggleImage1Mode()"
      (keydown.space)="toggleImage1Mode()"
    ></span>
  </div>
  <div class="cr-p2-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['PropertyUsp2x1Image'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyUsp2x1Image')"
      [placeholder]="image1Placeholder"
      variable="PropertyUsp2x1Image"
      [isImage]="image1AsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-p2-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['PropertyUsp2x1Image']">
      <div class="cr-p2-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-p2-title">Upload image</div>
      <div class="cr-p2-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-p2-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['PropertyUsp2x1ImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyUsp2x1ImageHref')"
      [placeholder]="image1HrefPlaceholder"
      variable="PropertyUsp2x1ImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyUsp2x1ImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['PropertyUsp2x1ImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['PropertyUsp2x1ImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp2x1ImageAlt')"
    [placeholder]="image1AltPlaceholder"
    [maxLength]="500"
    variable="PropertyUsp2x1ImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-p2-field-row">
    <span class="cr-p2-field-label">Second Image</span>
    <span
      class="cr-p2-toggle"
      [class.cr-p2-toggle-on]="image2AsUpload"
      role="button"
      tabindex="0"
      [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImage2Mode()"
      (keydown.enter)="toggleImage2Mode()"
      (keydown.space)="toggleImage2Mode()"
    ></span>
  </div>
  <div class="cr-p2-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['PropertyUsp2x2Image'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyUsp2x2Image')"
      [placeholder]="image2Placeholder"
      variable="PropertyUsp2x2Image"
      [isImage]="image2AsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-p2-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['PropertyUsp2x2Image']">
      <div class="cr-p2-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-p2-title">Upload image</div>
      <div class="cr-p2-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-p2-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['PropertyUsp2x2ImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyUsp2x2ImageHref')"
      [placeholder]="image2HrefPlaceholder"
      variable="PropertyUsp2x2ImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyUsp2x2ImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['PropertyUsp2x2ImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['PropertyUsp2x2ImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp2x2ImageAlt')"
    [placeholder]="image2AltPlaceholder"
    [maxLength]="500"
    variable="PropertyUsp2x2ImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp2xName'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp2xName')"
    [placeholder]="namePlaceholder"
    [maxLength]="500"
    variable="PropertyUsp2xName"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp2x1Usp'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp2x1Usp')"
    [placeholder]="usp1Placeholder"
    [maxLength]="4000"
    variable="PropertyUsp2x1Usp"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp2x2Usp'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp2x2Usp')"
    [placeholder]="usp2Placeholder"
    [maxLength]="4000"
    variable="PropertyUsp2x2Usp"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp2x3Usp'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp2x3Usp')"
    [placeholder]="usp3Placeholder"
    [maxLength]="4000"
    variable="PropertyUsp2x3Usp"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
